export const stats = [
  { value: '8', label: 'Volumi Completi' },
  { value: '500+', label: 'Pagine di Risorse' },
  { value: '80+', label: 'Unità Didattiche' },
  { value: '100%', label: "Pronto per l'Aula" },
]

export const beforeItems = [
  'Passare le domeniche a cercare disperatamente esercizi, problemi e schede online.',
  'Fotocopie sparse e materiali presi da fonti diverse senza una progressione chiara.',
  'Ansia da «ultimo minuto» prima di entrare in classe.',
  'Creare da zero verifiche, esercizi e materiali per livelli diversi.',
  'Perdere ore a cercare un modo semplice per spiegare concetti che gli alunni fanno fatica a capire.',
]

export const afterItems = [
  'Un intero anno mappato e organizzato, dalla 1ª Primaria alla 3ª Media.',
  'Lezioni visuali, esercizi e attività pronti per la stampa o per la LIM.',
  'Un percorso logico e progressivo che costruisce le competenze matematiche anno dopo anno.',
  'Verifiche già pronte per controllare rapidamente la comprensione degli studenti.',
  'Più tempo per insegnare, meno ore passate a preparare materiale da zero.',
]

export type Volume = {
  grade: string
  title: string
  text: string
}

export const primaryVolumes: Volume[] = [
  {
    grade: 'Classe 1ª',
    title: 'Numeri e Quantità',
    text: 'Numeri, quantità, conteggio, confronto e primi calcoli attraverso attività visuali e concrete.',
  },
  {
    grade: 'Classe 2ª',
    title: 'Operazioni e Strategie',
    text: 'Tabelline, calcolo in colonna, strategie numeriche e problemi guidati.',
  },
  {
    grade: 'Classe 3ª',
    title: 'Grandi Numeri e Misure',
    text: 'Moltiplicazioni, divisioni, misure e introduzione alla geometria.',
  },
  {
    grade: 'Classe 4ª',
    title: 'Frazioni e Decimali',
    text: 'Frazioni, numeri decimali e concetti complessi resi visuali e semplici da capire.',
  },
  {
    grade: 'Classe 5ª',
    title: 'Logica e Geometria',
    text: 'Geometria, dati, previsioni, logica e preparazione al passaggio alla scuola media.',
  },
]

export const secondaryVolumes: Volume[] = [
  {
    grade: '1ª Media',
    title: 'Aritmetica e Geometria Piana',
    text: 'Numeri, operazioni, divisibilità, frazioni e fondamenti di geometria piana.',
  },
  {
    grade: '2ª Media',
    title: 'Rapporti, Proporzioni e Algebra',
    text: 'Rapporti, proporzioni, percentuali e prime basi del ragionamento algebrico.',
  },
  {
    grade: '3ª Media',
    title: 'Equazioni, Geometria Solida ed Esame di Stato',
    text: "Equazioni, geometria solida, problemi e preparazione completa all'Esame di Stato.",
  },
]

export const bonuses = [
  {
    title: 'Matematica Pronta in 10 Minuti',
    value: '€14,99',
    text: 'La guida rapida per organizzare il materiale e preparare il tuo anno senza perdere ore.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c8694d12-762b-4335-84fc-a8efea22bdfc.jpg',
  },
  {
    title: 'Il Caveau del Calcolo Mentale',
    value: '€9,99',
    text: '100 attività rapide per attivare la classe, allenare il calcolo e iniziare ogni lezione con il piede giusto.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/43375fde-b968-4092-952f-56263d1b894d.jpg',
  },
  {
    title: 'Ganci Matematici dal Mondo Reale',
    value: '€7,99',
    text: '50 scenari pronti per mostrare agli studenti dove la matematica incontra la vita reale.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/dbb6898f-dfcb-4722-8e8f-d7a0e7ac0a7b.jpg',
  },
  {
    title: 'Matrice di Personalizzazione BES/DSA',
    value: '€5,99',
    text: 'Strategie e adattamenti rapidi per rendere le attività più accessibili senza ricreare ogni lezione da zero.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/6f2d0c62-f536-44bd-b2bf-e01f7e036c0c.jpg',
  },
  {
    title: 'Kit Comunicazione Famiglia e Progressi',
    value: '€4,99',
    text: 'Modelli pronti per comunicare progressi, difficoltà e risultati alle famiglie in modo semplice e professionale.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/1123214a-35d9-4064-bc1c-dce0fad625f7.jpg',
  },
]

export const offerRows = [
  { label: 'Pack Matematica Pronta (8 Volumi)', value: '€197' },
  { label: '5 Bonus Strategici', value: '€44,95' },
]

export const testimonials = [
  {
    quote:
      'Prima passavo ore a cercare esercizi diversi per ogni argomento. Adesso apro il volume della mia classe e ho già una progressione chiara da seguire.',
    name: 'Chiara L.',
    role: 'Insegnante Scuola Primaria',
  },
  {
    quote:
      'Finalmente un materiale di matematica organizzato davvero per classe. Le attività visuali mi aiutano tantissimo soprattutto con gli alunni che fanno più fatica.',
    name: 'Stefano M.',
    role: 'Docente Scuola Media',
  },
]

export const faqs = [
  {
    q: 'In che formato sono i materiali?',
    a: 'Tutti i materiali sono forniti in formato PDF digitale ad alta risoluzione, pronti per essere visualizzati su computer o tablet e stampati quando vuoi.',
  },
  {
    q: 'È adatto anche a chi insegna più classi?',
    a: 'Sì. Il pack contiene 8 volumi organizzati dalla 1ª Primaria alla 3ª Media, così puoi utilizzare il materiale in base alla classe che insegni.',
  },
  {
    q: 'Come ricevo il materiale?',
    a: "Subito dopo l'acquisto riceverai l'accesso digitale al pacchetto completo.",
  },
  {
    q: 'Posso usarlo su tablet?',
    a: 'Sì. Puoi consultare i PDF su computer, tablet o altri dispositivi compatibili oppure stamparli.',
  },
]

export const heroGuarantees = [
  'Download digitale istantaneo',
  'PDF pronti per la stampa',
  'Pagamento unico',
]

export const footerLinks = ['Termini e Condizioni', 'Privacy Policy', 'Contatti']
